module.exports = {"id":true,"storeCode":true,"name":true}


//////////////////
// WEBPACK FOOTER
// ./src/schemas/user/stores.json
// module id = /fPQ
// module chunks = 1